module.exports = __webpack_public_path__ + "static/media/protagonist-logo512x512.19c3d788.png";